export function formatVigenciaBolsaFamilia(vigencia: string) {
  if (vigencia.length !== 6) return '-'
  const semestre = vigencia.substring(4)
  const ano = vigencia.substring(0, 4)
  return `${semestre}/${ano}`
}
